import { constructFrom as c } from "./constructFrom.js";
import { getDaysInMonth as i } from "./getDaysInMonth.js";
import { toDate as m } from "./toDate.js";
function d(e, n) {
  const t = m(e), r = t.getFullYear(), s = t.getDate(), o = c(e, 0);
  o.setFullYear(r, n, 15), o.setHours(0, 0, 0, 0);
  const a = i(o);
  return t.setMonth(n, Math.min(s, a)), t;
}
export {
  d as default,
  d as setMonth
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/setMonth.js
// module id = 452
// module chunks = 67